module.exports = {
  ONTIME: 'Em dia',
  LATE: 'Atrasado',
  PENDING: 'Pendente',
  FINISHED: 'Finalizada'
}
